// extracted by mini-css-extract-plugin
export var cell = "_4s-4";
export var headerCell = "_4s-2";
export var rowHeader = "_4s-3";
export var table = "_4s-1";
export var tableContainer = "_4s-0";